<div class="messages-container">
  <div class="message-section">
    <div class="section-header">
      <h4>{{ 'components.message.patient.header' | translate }}</h4>
      <button type="button" class="btn-create" (click)="createMessagePatient()">
        {{ 'components.message.createButton' | translate }}
      </button>
    </div>
    <label>{{ 'components.message.modelLabel' | translate }}</label>
    <div class="select-with-delete">
      <select [(ngModel)]="titrePatient" (ngModelChange)="onTitrePatientChange($event)" [disabled]="emailTemplates().length === 0">
        <option *ngFor="let template of emailTemplates()" [value]="template.name">{{ template.name }}</option>
        <option *ngIf="emailTemplates().length === 0" value="" disabled>{{ 'components.message.createTemplateFirst' | translate }}</option>
      </select>
      <button type="button" class="btn-delete" (click)="clearTitrePatient()" [disabled]="emailTemplates().length === 0">
        <img src="assets/delete.svg" [attr.alt]="'components.message.deleteButtonAlt' | translate" />
      </button>
    </div>
    <label>{{ 'components.message.subjectLabel' | translate }}</label>
    <input
      [(ngModel)]="sujetPatient"
      [placeholder]="'components.message.subjectPlaceholder' | translate"
      [disabled]="emailTemplates().length === 0"
      (ngModelChange)="onSujetPatientChange($event)" />
    <label>{{ 'components.message.messageLabel' | translate }}</label>
    <textarea
      [(ngModel)]="messagePatient"
      [placeholder]="'components.message.patientMessagePlaceholder' | translate"
      [disabled]="emailTemplates().length === 0"
      (ngModelChange)="onMessagePatientChange($event)">
    </textarea>
    <button type="button" class="btn-save" (click)="saveMessagePatient()">
      {{ 'components.message.saveButton' | translate }}
    </button>
  </div>

  <div class="message-section">
    <div class="section-header">
      <h4>{{ 'components.message.news.header' | translate }}</h4>
      <button type="button" class="btn-create" (click)="createMessageRapide()">
        {{ 'components.message.createButton' | translate }}
      </button>
    </div>
    <label>{{ 'components.message.modelLabel' | translate }}</label>
    <div class="select-with-delete">
      <select [(ngModel)]="titreRapide" (ngModelChange)="onTitreRapideChange($event)" [disabled]="newsTemplates().length === 0">
        <option *ngFor="let template of newsTemplates()" [value]="template.name">{{ template.name }}</option>
        <option *ngIf="newsTemplates().length === 0" value="" disabled>{{ 'components.message.createTemplateFirst' | translate }}</option>
      </select>
      <button type="button" class="btn-delete" (click)="clearTitreRapide()" [disabled]="newsTemplates().length === 0">
        <img src="assets/delete.svg" [attr.alt]="'components.message.deleteButtonAlt' | translate" />
      </button>
    </div>
    <label>{{ 'components.message.messageLabel' | translate }}</label>
    <textarea
      [(ngModel)]="message"
      [placeholder]="'components.message.newsMessagePlaceholder' | translate"
      [disabled]="newsTemplates().length === 0"
      (ngModelChange)="onMessageChange($event)">
    </textarea>
    <button type="button" class="btn-save" (click)="saveMessageRapide()">
      {{ 'components.message.saveButton' | translate }}
    </button>
  </div>

  <div class="message-section">
    <div class="section-header">
      <h4>{{ 'components.message.action.header' | translate }}</h4>
      <button type="button" class="btn-create" (click)="createActionTemplate()">
        {{ 'components.message.createButton' | translate }}
      </button>
    </div>
    <label>{{ 'components.message.modelLabel' | translate }}</label>
    <div class="select-with-delete">
      <select [(ngModel)]="titreAction" (ngModelChange)="onTitreActionChange($event)" [disabled]="actionTemplates().length === 0">
        <option *ngFor="let template of actionTemplates()" [value]="template.name">{{ template.name }}</option>
        <option *ngIf="actionTemplates().length === 0" value="" disabled>{{ 'components.message.createTemplateFirst' | translate }}</option>
      </select>
      <button type="button" class="btn-delete" (click)="clearTitreAction()" [disabled]="actionTemplates().length === 0">
        <img src="assets/delete.svg" [attr.alt]="'components.message.deleteButtonAlt' | translate" />
      </button>
    </div>
    <label>{{ 'components.message.descriptionLabel' | translate }}</label>
    <textarea
      [(ngModel)]="messageAction"
      [placeholder]="'components.message.descriptionPlaceholder' | translate"
      [disabled]="actionTemplates().length === 0"
      (ngModelChange)="onMessageActionChange($event)">
    </textarea>
    <button type="button" class="btn-save" (click)="saveActionTemplate()">
      {{ 'components.message.saveButton' | translate }}
    </button>
  </div>
</div>

<app-template-create-modal
  *ngIf="showTemplateModal"
  (created)="onTemplateCreated($event)"
  (close)="onTemplateModalClose()">
</app-template-create-modal>

<app-news-template-modal
  *ngIf="showNewsTemplateModal"
  (created)="onNewsTemplateCreated($event)"
  (close)="onNewsTemplateModalClose()">
</app-news-template-modal>

<app-action-template-modal
  *ngIf="showActionTemplateModal"
  (created)="onActionTemplateCreated($event)"
  (close)="onActionTemplateModalClose()">
</app-action-template-modal>

<app-confirm-modal
  *ngIf="showDeleteConfirm"
  [title]="'components.message.confirmDelete.title' | translate"
  [message]="'components.message.confirmDelete.message' | translate"
  [confirmText]="'components.message.confirmDelete.confirm' | translate"
  [cancelText]="'components.message.confirmDelete.cancel' | translate"
  (confirm)="confirmDeleteTemplate()"
  (cancel)="cancelDeleteTemplate()">
</app-confirm-modal>
